/* Búsqueda predictiva del encabezado (Shopify Predictive Search API).
   Sin JS, el ícono es un enlace normal a /search. */
(function () {
  var btn = document.getElementById('psxBtn'), box = document.getElementById('psx');
  if (!btn || !box || !window.fetch) return;
  var root = document.documentElement, panel = box.querySelector('.psx-panel'), input = box.querySelector('.psx-in'),
    list = box.querySelector('.psx-list'), status = box.querySelector('.psx-status'), hint = box.querySelector('[data-psx-hint]'),
    all = box.querySelector('[data-psx-all]'), form = box.querySelector('.psx-form'), scan = box.querySelector('.psx-scan');
  var D = box.dataset, hide = (D.hide || '').trim().toLowerCase();
  var reduce = matchMedia('(prefers-reduced-motion: reduce)');
  var timer = 0, ctrl = null, active = -1, opener = btn, lastQ = '', seq = 0;
  var money = (function () { try { var f = new Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }), f0 = new Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN', minimumFractionDigits: 0, maximumFractionDigits: 0 }); return function (v) { v = +v || 0; return (v % 1 ? f : f0).format(v); }; } catch (e) { return function (v) { return '$' + (+v || 0).toFixed(2); }; } })();
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  var stripW = (D.strip || '').split(',').map(function (w) { return w.trim(); }).filter(Boolean);
  function cleanTitle(t, vendor) {
    t = String(t || ''); var v = String(vendor || '').trim(), vl = v.toLowerCase();
    [' | ', ' – ', ' — ', ' - ', ' · '].forEach(function (sep) {
      if (t.indexOf(sep) < 0) return;
      var parts = t.split(sep), keep = [parts[0]];
      parts.slice(1).forEach(function (seg) {
        var sl = seg.trim().toLowerCase();
        var drop = !sl || sl === '|' || sl === '–' || (vl && sl.indexOf(vl) > -1) || stripW.some(function (w) { return sl.indexOf(w.toLowerCase()) > -1; });
        if (!drop) keep.push(seg);
      });
      t = keep.join(sep).trim();
    });
    if (v && !/^nootr[oó]picos m[eé]xico$/i.test(v)) t = t.split(v).join('');
    stripW.forEach(function (w) { t = t.split(w).join(''); });
    t = t.replace(/\s{2,}/g, ' ').trim();
    for (var i = 0; i < 4; i++) t = t.replace(/\s*(\||–|—|-|·|\(|\bde|\bcon)\s*$/i, '').trim();
    t = t.replace(/[Pp][ií]ldoras/g, 'píldoras').replace(/[Pp]ildora\b/g, 'píldoras').replace(/Píldora\b/g, 'píldora').replace(/C[aá]psulas/g, 'cápsulas').replace(/Tabletas/g, 'tabletas').replace(/(\d)mg\b/g, '$1 mg');
    return t.charAt(0).toUpperCase() + t.slice(1);
  }
  function nrm(c) { return c.normalize ? c.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase() : c.toLowerCase(); }
  /* Resalta las letras coincidentes (sin distinguir acentos ni mayúsculas) */
  function hl(text, q) {
    text = String(text || ''); var map = [], n = '';
    for (var i = 0; i < text.length; i++) { var c = nrm(text[i]); for (var k = 0; k < c.length; k++) { n += c[k]; map.push(i); } }
    var mark = new Array(text.length + 1).join('0').split('');
    nrm(q).split(/\s+/).filter(Boolean).forEach(function (t) {
      var from = 0, at; while ((at = n.indexOf(t, from)) > -1) { for (var j = at; j < at + t.length; j++) mark[map[j]] = '1'; from = at + t.length; }
    });
    var out = '', on = false;
    for (var x = 0; x < text.length; x++) { var m = mark[x] === '1'; if (m && !on) out += '<mark>'; if (!m && on) out += '</mark>'; on = m; out += esc(text[x]); }
    return out + (on ? '</mark>' : '');
  }
  function thumb(p) {
    var u = (p.featured_image && p.featured_image.url) || p.image || '';
    if (!u) return '';
    if (/cdn\.shopify|\/cdn\/shop\//.test(u)) u += (u.indexOf('?') > -1 ? '&' : '?') + 'width=128';
    return u;
  }
  function hasHidden(p) {
    if (!hide) return false;
    var t = p.tags; if (typeof t === 'string') t = t.split(',');
    return Array.isArray(t) && t.some(function (x) { return String(x).trim().toLowerCase() === hide; });
  }
  function price(p) {
    var lo = p.price_min != null ? p.price_min : p.price, hi = p.price_max != null ? p.price_max : lo;
    var s = money(lo); return (+hi > +lo) ? (D.from || 'Desde __P__').replace('__P__', s) : s;
  }
  function searchUrl(q) { return (D.search || '/search') + '?q=' + encodeURIComponent(q) + '&options%5Bprefix%5D=last'; }
  function opts() { return list.querySelectorAll('[role="option"]'); }
  function setActive(i) {
    var o = opts(); if (!o.length) { active = -1; input.removeAttribute('aria-activedescendant'); return; }
    active = (i + o.length) % o.length;
    for (var k = 0; k < o.length; k++) o[k].setAttribute('aria-selected', String(k === active));
    input.setAttribute('aria-activedescendant', o[active].id); o[active].scrollIntoView({ block: 'nearest' });
  }
  function sweep() { if (!scan || reduce.matches) return; scan.classList.remove('run'); void scan.offsetWidth; scan.classList.add('run'); }
  function render(q, r) {
    var prods = (r.products || []).filter(function (p) { return !hasHidden(p); }).slice(0, 6),
      cols = (r.collections || []).slice(0, 3), qs = (r.queries || []).filter(function (s) { return nrm(s.text || '') !== nrm(q); }).slice(0, 3);
    var h = '', i = 0;
    function head(t) { return '<li class="psx-h" role="presentation">' + esc(t) + '</li>'; }
    if (qs.length) { h += head(D.qs); qs.forEach(function (s) { h += '<li class="psx-q" role="presentation" style="--i:' + (i) + '"><a role="option" id="psx-o' + (i++) + '" href="' + esc(s.url || searchUrl(s.text)) + '" aria-selected="false"><span class="psx-qi" aria-hidden="true">↗</span>' + hl(s.text, q) + '</a></li>'; }); }
    if (prods.length) {
      h += head(D.prods);
      prods.forEach(function (p) {
        var src = thumb(p), sold = p.available === false;
        h += '<li class="psx-p" role="presentation" style="--i:' + i + '"><a role="option" id="psx-o' + (i++) + '" href="' + esc(p.url) + '" aria-selected="false">' +
          '<span class="psx-t">' + (src ? '<img src="' + esc(src) + '" alt="" width="56" height="56" loading="lazy" decoding="async">' : '') + '</span>' +
          '<span class="psx-m"><b>' + hl(cleanTitle(p.title, p.vendor), q) + '</b>' + (p.vendor ? '<small>' + hl(p.vendor, q) + '</small>' : '') + '</span>' +
          '<span class="psx-pr' + (sold ? ' is-sold' : '') + '">' + esc(price(p)) + '</span></a></li>';
      });
    }
    if (cols.length) { h += head(D.cols); cols.forEach(function (c) { h += '<li class="psx-c" role="presentation" style="--i:' + i + '"><a role="option" id="psx-o' + (i++) + '" href="' + esc(c.url) + '" aria-selected="false"><span class="psx-ci" aria-hidden="true"></span>' + hl(c.title, q) + '</a></li>'; }); }
    list.innerHTML = h; active = -1; input.removeAttribute('aria-activedescendant');
    var any = prods.length + cols.length + qs.length > 0;
    status.textContent = any ? '' : (D.none || '').replace('__Q__', q);
    box.classList.toggle('has-res', any); box.classList.remove('is-loading');
    input.setAttribute('aria-expanded', String(any));
    all.hidden = false; all.href = searchUrl(q);
    sweep();
  }
  function query(q) {
    if (ctrl) ctrl.abort();
    ctrl = window.AbortController ? new AbortController() : null;
    var my = ++seq; box.classList.add('is-loading');
    var url = (D.url || '/search/suggest.json') + '?q=' + encodeURIComponent(q) +
      '&resources%5Btype%5D=product%2Ccollection%2Cquery&resources%5Blimit%5D=6&resources%5Boptions%5D%5Bunavailable_products%5D=last';
    fetch(url, { signal: ctrl ? ctrl.signal : undefined, headers: { Accept: 'application/json' } })
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
      .then(function (j) { if (my !== seq || input.value.trim() !== q) return; render(q, (j.resources && j.resources.results) || {}); })
      .catch(function (e) { if (e && e.name === 'AbortError') return; if (my === seq) { box.classList.remove('is-loading'); status.textContent = ''; all.hidden = false; all.href = searchUrl(q); } });
  }
  function onInput() {
    var q = input.value.trim(); clearTimeout(timer);
    if (q === lastQ) return; lastQ = q;
    if (q.length < 2) {
      if (ctrl) ctrl.abort(); seq++;
      list.innerHTML = ''; status.textContent = ''; all.hidden = true; hint.hidden = false;
      box.classList.remove('has-res', 'is-loading'); input.setAttribute('aria-expanded', 'false'); return;
    }
    hint.hidden = true; timer = setTimeout(function () { query(q); }, 150);
  }
  function origin() {
    var r = (opener && opener.getBoundingClientRect && opener.offsetParent !== null ? opener : btn).getBoundingClientRect();
    var pr = panel.getBoundingClientRect();
    panel.style.setProperty('--ox', Math.round(r.left + r.width / 2 - pr.left) + 'px');
    panel.style.setProperty('--oy', Math.round(r.top + r.height / 2 - pr.top) + 'px');
  }
  function isOpen() { return btn.getAttribute('aria-expanded') === 'true'; }
  function open(from) {
    if (isOpen()) return; opener = from || btn;
    if (root.classList.contains('mnav-on')) { var nb = document.getElementById('navBtn'); if (nb) nb.click(); opener = btn; }
    box.hidden = false; origin();
    btn.setAttribute('aria-expanded', 'true'); root.classList.add('psx-on');
    if (window.lenis && window.lenis.stop) window.lenis.stop();
    requestAnimationFrame(function () { requestAnimationFrame(function () { box.classList.add('open'); sweep(); }); });
    input.focus({ preventScroll: true }); if (input.value.trim().length >= 2) input.select();
  }
  function close(back) {
    if (!isOpen()) return;
    btn.setAttribute('aria-expanded', 'false'); box.classList.remove('open'); root.classList.remove('psx-on');
    if (window.lenis && window.lenis.start) window.lenis.start();
    if (ctrl) ctrl.abort(); clearTimeout(timer);
    setTimeout(function () { if (!isOpen()) box.hidden = true; }, reduce.matches ? 0 : 320);
    if (back !== false) (opener && opener.offsetParent !== null ? opener : btn).focus({ preventScroll: true });
  }
  btn.addEventListener('click', function (e) { e.preventDefault(); isOpen() ? close() : open(btn); });
  document.addEventListener('click', function (e) {
    var o = e.target.closest('[data-psx-open]'); if (o) { e.preventDefault(); open(o); return; }
    if (e.target.closest('[data-psx-close]') && box.contains(e.target)) close();
  });
  input.addEventListener('input', onInput);
  input.addEventListener('keydown', function (e) {
    var n = opts().length;
    if (e.key === 'ArrowDown') { if (n) { e.preventDefault(); setActive(active + 1); } }
    else if (e.key === 'ArrowUp') { if (n) { e.preventDefault(); setActive(active < 0 ? n - 1 : active - 1); } }
    else if (e.key === 'Enter') {
      var o = opts();
      if (active > -1 && o[active]) { e.preventDefault(); o[active].click(); }
      else if (input.value.trim().length) { e.preventDefault(); location.href = searchUrl(input.value.trim()); }
      else e.preventDefault();
    }
  });
  form.addEventListener('submit', function (e) { e.preventDefault(); var q = input.value.trim(); if (q) location.href = searchUrl(q); });
  list.addEventListener('mousemove', function (e) { var a = e.target.closest('[role="option"]'); if (!a) return; var o = opts(); for (var k = 0; k < o.length; k++) if (o[k] === a && k !== active) setActive(k); });
  list.addEventListener('click', function (e) { if (e.target.closest('a')) close(false); });
  box.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { e.preventDefault(); close(); return; }
    if (e.key === 'Tab') { /* foco atrapado dentro del panel */
      var f = Array.prototype.filter.call(box.querySelectorAll('input:not([type=hidden]),button,a[href]:not([hidden])'), function (x) { return x.offsetParent !== null; });
      if (!f.length) return; var a = f[0], z = f[f.length - 1];
      if (e.shiftKey && document.activeElement === a) { e.preventDefault(); z.focus(); }
      else if (!e.shiftKey && document.activeElement === z) { e.preventDefault(); a.focus(); }
    }
  });
  addEventListener('resize', function () { if (isOpen()) origin(); });
  /* Atajo: «/» abre la búsqueda (si no se está escribiendo) */
  document.addEventListener('keydown', function (e) {
    if (e.key !== '/' || isOpen() || e.metaKey || e.ctrlKey || e.altKey) return;
    var t = e.target; if (t && (t.isContentEditable || /^(input|textarea|select)$/i.test(t.tagName))) return;
    e.preventDefault(); open(btn);
  });
})();
